export function pageTop(pageTopButtonEl, hide) {
  const $pageTopButton = $(pageTopButtonEl);
  if (hide) {
    $pageTopButton.hide();
    $(window).scroll(function () {
      const $scrollTop = $(this).scrollTop();
      if ($scrollTop) {
        if ($scrollTop > 500) {
          $pageTopButton.fadeIn();
        } else {
          $pageTopButton.fadeOut();
        }
      }
    });
  }
  $pageTopButton.click(function (event) {
    const rootElement = document.documentElement;
    const previousScrollBehavior = rootElement.style.scrollBehavior;

    event.preventDefault();
    rootElement.style.scrollBehavior = "auto";

    $("html, body")
      .stop(true)
      .animate(
      {
        scrollTop: 0,
      },
      500,
      "linear"
    )
      .promise()
      .done(function () {
        rootElement.style.scrollBehavior = previousScrollBehavior;
      });
    return false;
  });
}
